/**
 * The roles a verified-domain join may give (plan-014 B3, migration 0089's CHECK): every workspace role but Owner and
 * Admin — those are given by a person, by invitation. The server refuses them too; this is what the form offers.
 */
import type { MemberRoleView } from "../../api/gateway.js";

export function isConstrainedJoinRoleView(role: MemberRoleView): boolean {
  return role !== "owner" && role !== "admin";
}
